module.exports = __webpack_public_path__ + "static/media/ly.822fe887.jpeg";